<app-sidebar></app-sidebar>
<app-mobile-header></app-mobile-header>

<div class="main-create-job-offer">
    <div id="content" class="main-content" role="main"> 
        <img src="/assets/logo_2x.png" alt="Conectio Logo" class="logo hideInMobile">
        <h2 style="padding-top: 20px;">{{ 'createJobOffer.step4.title' | translate }}</h2>

        <p style="padding-bottom:30px;">{{ 'createJobOffer.step4.description' | translate }}</p>

        <h4 style="padding-bottom:10px;">{{ 'createJobOffer.step4.whatNext' | translate }}</h4>

        <div class="beneficios-container">
            <div class="beneficios-item">
                <div class="circles">
                    <img src="/assets/graph_end.png" alt="Check" class="black-circle">
                </div>
                <b>{{ 'createJobOffer.step4.items.configure' | translate }}</b>

            </div>
            <div class="beneficios-item">
                <div class="circles">
                    <img src="/assets/person_end.png" alt="Check" class="black-circle">

                </div>
                <b>{{ 'createJobOffer.step4.items.contact' | translate }}</b>

            </div>
            <div class="beneficios-item">
                <div class="circles">
                    <img src="/assets/idionity_end.png" alt="Check" class="black-circle">
                </div>
                <b>{{ 'createJobOffer.step4.items.validate' | translate }}</b>

            </div>
            <div class="beneficios-item">
                <div class="circles">
                    <img src="/assets/match_end.png" alt="Check" class="black-circle">
                </div>
                <b>{{ 'createJobOffer.step4.items.propose' | translate }}</b>

            </div>

            <div class="line-beneficios hideInMobile"></div>
        </div>

        <div class="actions two-actions" style="margin-top: 60px; padding-bottom: 80px;justify-content: end !important">
            <div class = "actions-left">
                
            </div>
            <div class = "actions-right" > 
                <a href="/dashboard/company" target="_blank" rel="noopener noreferrer">

                <button mat-raised-button color="primary" class = "linkedin-button" (click)="true">
                    <span  *ngIf="!loading">{{ 'createJobOffer.step4.actions.goToDashboard' | translate }}</span>
                </button>
                </a>

            </div>
            
        </div>
    </div>
</div>
